import React, { ReactNode } from "react";

interface MessageBlockProps {
  children: ReactNode;
}

export const MessageBlock = ({ children }: MessageBlockProps): React.ReactElement => {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">{children}</div>
    </div>
  );
};
